module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/table-responsive-2/table-responsive-2.component.scss
// module id = ./src/app/features/typography/table-responsive-2/table-responsive-2.component.scss
// module chunks = main